// import _ from 'lodash';
import { cleanCartItem } from '../selectors/converterSelectors'

const products3pl = {
  isLoading: false,
  list: {},
  userInput: {},
}
const Products3PLReducer = function (state = products3pl, action) {
  switch (action.type) {
    case 'TOGGLE_PRODUCT_LIST_SUPPLIER_LOADING': {
      return {
        ...state,
        isLoading: action.value,
      }
    }
    case 'UPDATE_PRODUCTS_LIST_3PL': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case 'UPDATE_PRODUCT_3PL_USER_INPUT': {
      const { qty_per_case, soh, id } = action.row
      let newUserInputRecord =
        typeof state.userInput[action.row.id] != 'undefined'
          ? { ...state.userInput[id] }
          : { productID: id, soh: soh, qty_per_case: qty_per_case, unitQty: 0, caseQty: 0 }
      newUserInputRecord[action.key] = action.value

      let newUserInput = {
        ...state.userInput,
        [id]: newUserInputRecord,
      }

      // Now restructure them
      // @TODO: Handle the input fields properly
      newUserInput[id] = cleanCartItem(newUserInput[id], state.list[id], 'product')

      return {
        ...state,
        userInput: newUserInput,
      }
    }
    case 'CLEAR_ALL_PRODUCT_3PL_USER_INPUT': {
      return {
        ...state,
        userInput: {},
      }
    }
    default: {
      return state
    }
  }
}

export default Products3PLReducer
